export default __webpack_public_path__ + "static/media/Arrow.cd40254c.svg";